"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0; // ARCHITECT-MIXINS [ MEDIA QUERY ] ############################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. DEFAULTS ...............................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

var _default = {
  s: '(max-width: 480px)',
  m: '(min-width: 481px) and (max-width: 1023px)',
  l: '(min-width: 1024px) and (max-width: 1440px)',
  xl: '(min-width: 1441px)'
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################

exports["default"] = _default;